// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import * as VueMoment from 'vue-moment'
// import * as VuePusher from 'vue-pusher'
import VueLoading from 'vuex-loading'
import filters from './utils/GlobalFilters'
import Vuebar from 'vuebar'
import VueWorker from 'vue-worker'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { RecycleScroller } from 'vue-virtual-scroller'
import i18n from './utils/i18'

Vue.component('RecycleScroller', RecycleScroller)

Vue.use(Vuetify, {
  iconfont: 'mdi'
})
Vue.use(Vuebar)
Vue.use(VueWorker)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyClTNyYfwvUoTBgiX6Dh7_Kuwr_t746fb0',
    v: '3.50',
    libraries: 'geometry,drawing,places'
  }
})
Vue.use(VueMoment)

// Vue.use(VuePusher, {
//   api_key: process.env.API_KEY_PUSHER,
//   options: {
//     encrypted: true,
//     cluster: 'mt1',
//     // authTransport: 'jsonp',
//     authEndpoint: PUSHER_AUTH_URL
//   }
// })

Vue.use(filters)
Vue.use(VueLoading) // add VueLoading as Vue plugin
Vue.config.productionTip = false

Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  vueLoading: new VueLoading({useVuex: true, registerComponents: false}),
  components: {App},
  template: '<App/>',
  created() {
    if (process.env.NODE_ENV !== 'production') {
      console.log('NODE_ENV', process.env.NODE_ENV)
      // console.log('AUTH_URL', process.env.AUTH_URL)
      // console.log('API_URL', process.env.API_URL)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js